import badgeSecure from "@/assets/badge-secure.png";
import badgeSsl from "@/assets/badge-ssl.png";
import badgeInstant from "@/assets/badge-instant.png";

const badges = [
  {
    image: badgeSecure,
    text: "Sicherer Kauf"
  },
  {
    image: badgeSsl,
    text: "SSL-Verschlüsselt"
  },
  {
    image: badgeInstant,
    text: "Sofort-Download"
  }
];

const TrustBadges = () => {
  return (
    <div className="flex flex-wrap items-center justify-center gap-4 py-12">
      {badges.map((badge, index) => {
        return (
          <div
            key={index}
            className="flex items-center gap-3 px-5 py-3 rounded-xl bg-gradient-to-br from-card to-card/80 border border-primary/10 shadow-soft hover:shadow-premium hover:border-primary/30 transition-all duration-300 group hover-lift"
            style={{ animationDelay: `${index * 100}ms` }}
          >
            <div className="w-10 h-10 rounded-lg flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
              <img 
                src={badge.image} 
                alt={badge.text}
                className="w-8 h-8 object-contain"
                width="512"
                height="512"
                loading="lazy"
              />
            </div>
            <span className="text-sm font-semibold text-foreground">{badge.text}</span>
          </div>
        );
      })}
    </div>
  );
};

export default TrustBadges;
